import React from 'react';
import { HiOutlineSearch } from 'react-icons/hi';

function SearchBar({ value, onChange, placeholder }) {
  return (
    <div className="search-container">
      <HiOutlineSearch className="search-icon" />
      <input
        type="text"
        className="search-input"
        placeholder={placeholder || 'Buscar em todas as categorias...'}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
}

export default SearchBar;
